import { EXPERIMENT_IDENTIFIERS } from '~server/routes/Pricing/experimentsConfig';
import { usePricingExperiments } from '~shared/hooks/usePricingExperiments';
import { Experience } from './types';

export default function useExperimentAssignment(): Experience {
  const { uiExperiment, priceExperiment, featureExperiment } = usePricingExperiments();

  const experience =
    (uiExperiment.hasAssignment && uiExperiment.treatmentName) ||
    (priceExperiment.hasAssignment && priceExperiment.treatmentName) ||
    (featureExperiment.hasAssignment && featureExperiment.treatmentName) ||
    '';

  const noFormsMonthly =
    priceExperiment.hasAssignment && priceExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment2;
  const noFormsAtAll =
    priceExperiment.hasAssignment && priceExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment3;

  const isPnPRefresh =
    priceExperiment.hasAssignment &&
    (priceExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment1 ||
      priceExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment2 ||
      priceExperiment.treatmentName === EXPERIMENT_IDENTIFIERS.GROW_2792.treatment3);

  return {
    experience,
    isPnPRefresh,
    noFormsAtAll,
    noFormsMonthly,
  };
}
